export default "__VITE_ASSET__27052e34__"